'use strict';

angular.module('lingApp')
  .directive('ripMain', function ($compile, $document, $rootScope, $window, RipContext, RipState, RipStrings) {

    return {
      template: require('views/rip-main.html'),
      restrict: 'E',
      link: function postLink(scope, element, attrs) {
        scope.pendingRequest = function() {
          return 0 < RipContext.pendingRequestCount;
        };

        scope.pendingRequestCompletion = function() {
          return 0 === RipContext.pendingRequestCount && 0 < RipContext.pendingRequestCompletionCount;
        };

        var unwatch = scope.$watch(function() { return RipContext.appInit; },
                                   function(val) {
                                     if (val) {
                                       RipState.setState($rootScope);

                                       view();

                                       unwatch();
                                     }
                                   });

        function view() {
          var path = $window.location.pathname || '';

          if (RipStrings.endsWith(path, '/resendPasswordResetEmail')) {
            element.append($compile('<rip-reset-password-link></rip-reset-password-link>')(scope));

          } else if (RipStrings.endsWith(path, '/forgotMyPassword')) {
            element.append($compile('<rip-reset-password></rip-reset-password>')(scope));

          } else if (RipStrings.endsWith(path, '/resetPassword')) {
            element.append($compile('<rip-reset-password></rip-reset-password>')(scope));

          } else if (RipStrings.endsWith(path, '/setInitialPassword')) {
            element.append($compile('<rip-reset-password initial="true"></rip-reset-password>')(scope));

          } else {
            element.append($compile('<rip-login></rip-login>')(scope));
          }
        }
      }
    };
  });
